export const colours = {
  dark: "#191919",
  medium: "#787878",
  light: "#f3f3f3",
  accent: "#033563",
  transpWhite: "rgba(255,255,255,0.9)",
  transpLight: "rgba(243,243,243,0.5)",
  transpDark: "rgba(25, 25, 25, 0.65)",
  transpBlack: "rgba(0, 0, 0, 0.9)",
};

export const heights = {
  headerHeight: "100px",
  mobileHeader: "80px",
  contactBar: "40px",
}

export const commonDimensions = {
  h2Margin: "20px"
}